import React from 'react'
import Chip from '../atoms/chip/Chip'

const InsuranceCarouselItem = ({ insuranceItem = {}, link } = {}) => (
  <Chip
    className="mb-0 mr-2 block h-[64px] min-w-[88px] rounded-xl p-1 px-[8px] first:ml-[32px] last:mr-[32px]"
    href={link}
    linkTitle={insuranceItem.title}
  >
    <img
      style={{
        filter:
          'invert(41%) sepia(24%) saturate(552%) hue-rotate(171deg) brightness(70%) contrast(95%)'
      }}
      className="w-full fill-gray-800"
      title={insuranceItem.title}
      src={insuranceItem.img}
    />
  </Chip>
)

export default InsuranceCarouselItem
